import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import News from '@/pages/News'
import Work from '@/pages/work'
import Category from '@/pages/work/Category'
import GoldenTicket from '@/pages/GoldenTicket'
import NotFound from '@/pages/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/',
      name: 'about',
      hash: 'about',
      component: Home,
    },
    {
      path: '/',
      name: 'contact',
      hash: 'contact-me',
      component: Home,
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta: {
        scrollToTop: true,
      },
    },
    {
      path: '/work',
      name: 'work',
      component: Work,
      meta: {
        scrollToTop: true,
      },
    },
    {
      path: '/work/:id',
      name: 'category',
      component: Category,
    },
    {
      path: '/goldenticket',
      name: 'goldenticket',
      component: GoldenTicket,
      meta: {
        scrollToTop: true,
      },
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js